import { APP_CONFIG } from "../constant/common";
import { iAppConfig } from "../types/common";
import { isConfigFlagEnabled } from "./configFlags";

/**
 * Whether the WebBeds extra-info behaviours are enabled (`WEBBED_EXTRA_INFO_ENABLED`).
 *
 * Gates BOTH of the things that flag covers — the "Extra Info" button under
 * "Pay now" on the review price panel, and collecting every guest's name on a
 * stays booking whose rate reports `allPaxDetailsRequired` — because they are one
 * supplier requirement that arrives together in the same response.
 *
 * Defaults OFF when the row is absent (`isConfigFlagEnabled`, not the
 * `…WithDefault` variant): neither behaviour exists in the product today, so
 * "no row" must mean "unchanged", not "roll it out".
 *
 * Note that `appConfig` is `undefined` on the first render, before the config
 * fetch resolves — indistinguishable from "no row", and correct either way: the
 * button simply appears once config lands, and the traveler-form branch is read
 * on the traveler step, long after.
 */
export const isWebbedExtraInfoEnabled = (appConfig: iAppConfig[] | undefined | null): boolean =>
  isConfigFlagEnabled(appConfig, APP_CONFIG.WEBBED_EXTRA_INFO_ENABLED);
